// extracted by mini-css-extract-plugin
export default {"loogout_modal":"LogoutModal_loogout_modal__Ghjzy","title":"LogoutModal_title__CBrJv","buttons":"LogoutModal_buttons__L48D9","cancel":"LogoutModal_cancel__dHrit"};